
(function($){
  if( $('.js-tour-itinerary-summary_a').length ){
      var $tourItinerarySummary = $('.js-tour-itinerary-summary_a');
      var $tableItinerarySummary = $tourItinerarySummary.find('table');
      $tableItinerarySummary.addClass('itinerary-summary-table');
      
      var foodHtml = '<i class="mdi mdi-silverware uk-text-primary"></i>';
      var airlineHtml = '<i class="mdi mdi-airplane uk-text-primary"></i>';
      var xHtml = '<i class="mdi mdi-close uk-text-danger"></i>';
      $tableItinerarySummary.find('td:contains("#F")').html(foodHtml);
      $tableItinerarySummary.find('td:contains("#A")').html(airlineHtml);
      $tableItinerarySummary.find('td:contains("#X")').html(xHtml);
      
      $tableItinerarySummary.find('tr:first-child').addClass('itinerary-summary-header');
      var countCol = $tableItinerarySummary.find('tr:first-child > td').length;
      $trLastChild = $tableItinerarySummary.find('tr:last-child');
      if( $trLastChild.find('td').length < countCol ){
          $trLastChild.addClass('itinerary-summary-notic');
          $trLastChild.find('td:last-child').attr('colspan', countCol );
      }
      $tourItinerarySummary.addClass('render');
  }
})(jQuery);